import { render, staticRenderFns } from "./BaseChoosePackageType.vue?vue&type=template&id=654d24fa&scoped=true&"
import script from "./BaseChoosePackageType.vue?vue&type=script&lang=js&"
export * from "./BaseChoosePackageType.vue?vue&type=script&lang=js&"
import style0 from "./BaseChoosePackageType.vue?vue&type=style&index=0&id=654d24fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654d24fa",
  null
  
)

export default component.exports